import { render, staticRenderFns } from "./TermsAndCondition.vue?vue&type=template&id=1f16ee20&scoped=true&"
import script from "./TermsAndCondition.vue?vue&type=script&lang=ts&"
export * from "./TermsAndCondition.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAndCondition.vue?vue&type=style&index=0&id=1f16ee20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f16ee20",
  null
  
)

export default component.exports